import { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { useAlertMessageContext } from "../../../contexts/alert-message.context";
import { useConfirmMessageContext } from "../../../contexts/confirm-message.context";
import cndService from "../../../services/cnd.service";
import { dateToString, notNullToDate } from "../../../utilities/auxiliary-functions";
import { removeFormatDate } from "../../../utilities/masks";
import { isEmpty } from "../../../utilities/validators";
import EncounterRecord from "../../records/encounter.record";
import { Button } from '@mui/material'
import { AlertMessageEnum } from "../../../utilities/types";
import { useTranslateContext } from "../../../contexts/translate.context";
import { usePartnerContext } from "../../../contexts/partner.context";
import authService from "../../../services/auth.service";

export interface IEncounterCondominiumFormProps {
    title: string,
    identifier: string,
    setRecord: any,
    viewOnly?: boolean
}

export const EncounterCondominiumForm: React.FC<IEncounterCondominiumFormProps> = (props: IEncounterCondominiumFormProps) => {

    const alertContext = useAlertMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const [ invalidatedForm, setInvalidatedForm ] = useState(false);
    const [ isEditForm, setEditForm ] = useState(true);

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ originRecord, setOriginRecord ] = useState({} as any);
    const [ sending, setSending ] = useState(false);

    /* TRATAMENTO PARTICULAR DO OBJETO QUE ESTA SENDO MANTIDO */
    // Encounter
    const [ encounterId, setEncounterId ] = useState(0);
    const [ launch, setLaunch ] = useState(dateToString(new Date(), 'dd/mm/yyyy')); 
    const [ norm, setNorm ] = useState(''); 
    const [ daily, setDaily ] = useState(''); 
    const [ subject, setSubject ] = useState(''); 
    const [ reason, setReason ] = useState(''); 
    const [ resolved, setResolved ] = useState(''); 
    const [ participants, setParticipants ] = useState(''); 
    const [ created, setCreated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));
    const [ updated, setUpdated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));

    const [ listEstate, setListEstate ] = useState([] as any);

    function fillRecord(encounter: any) {

        if (!isEmpty(encounter)) {
            setEncounterId(encounter.id);
            setLaunch(notNullToDate(encounter.launch, 'dd/mm/yyyy'));
            setNorm(encounter.norm);
            setDaily(notNullToDate(encounter.daily, 'dd/mm/yyyy HH:MM:ss'));
            setSubject(encounter.subject);
            setReason(encounter.reason);
            setResolved(encounter.resolved);
            setParticipants(encounter.participants);
            setCreated(notNullToDate(encounter.created, 'dd/mm/yyyy HH:MM:ss'));  
            setUpdated(notNullToDate(encounter.updated, 'dd/mm/yyyy HH:MM:ss'));  
        }
    } // fillRecord

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        /*
        if (isEmpty(fullname))
            emptyRequired = true;
        if (isEmpty(registrationPf))
            emptyRequired = true;
        if ((!isEmpty(registrationPf)) && (!isCpf(registrationPf))) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.registration_pf);
            result = false;
        }
        */

        if (emptyRequired) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.required);
            result = false;
        }

        setInvalidatedForm(!result);
        return result;
    } // isValidForm

    function onClick_CancelEncounter(event: any) {
        event.preventDefault();
        props.setRecord(event, 0);
    } // onClick_CancelEncounter

    function fillRegister() {

        const dataRegister = {
            id : encounterId,
            partnerId: partner.id,
            launch : removeFormatDate(launch), 
            norm, 
            daily : removeFormatDate(daily), 
            subject, 
            reason, 
            resolved, 
            participants, 
            created : removeFormatDate(created), 
            updated : removeFormatDate(updated)
        };

        return dataRegister;
    } // fillRegister

    async function onClick_SaveEncounter(event: any) {
        event.preventDefault();
        
        const isValid = await isValidForm();
        if (isValid) {
            try {
                const isConfirmed = await confirmContext.show(props.title, display.message.confirm_record);
                if (isConfirmed) {
                    setSending(true);

                    const encounter = fillRegister();
                    if (encounter.id > 0)
                        await cndService.saveEncounter(encounter.id,  encounter);
                    else
                        await cndService.createEncounter(encounter);

                    setSending(false);
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, display.message.the_record_has_been_saved_successfully);
                    props.setRecord(event, 0);
                }
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
            }
        }
    } // onClick_SaveEncounter
        
    async function changeEstate() {
        const attributes = ['id','name'];
        const result = await cndService.estateList(attributes);
        setListEstate(result.rows);
    }

    async function searchParam() {
        try {
            setEditForm(!props.viewOnly);
            if (!Number.isNaN(Number.parseInt(props.identifier ||''))) {

                const encounter = await cndService.encounterById(Number(props.identifier));
                setOriginRecord(encounter);
                fillRecord(encounter);
            }
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
        }
    } // searchParam

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            changeEstate();
            searchParam();
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    function viewCadastreForm() {

        return (
            <Container fluid className="page-body encounter">
                <Row>
                    <Col sm={12} className="page-sweet">
                        <Card>
                            <Card.Header>
                                {(originRecord.created || originRecord.updated) && (
                                    <div className="form-identy-registry float-right">
                                        <span className="white-space"><b>Criação: </b> {dateToString(originRecord.created, 'dd/mm/yyyy HH:MM:ss')}</span>
                                        <span className="white-space"><b>Atualização: </b> {dateToString(originRecord.updated, 'dd/mm/yyyy HH:MM:ss')}</span>
                                    </div>
                                )}
                                <Card.Title>{display.legend.record}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form className="form" id="form-cadastre" validated={invalidatedForm}>
                                    <EncounterRecord
                                        title={props.title}
                                        isEdit={isEditForm}
                                        identifier={encounterId === 0}
                                        viewOnly={props.viewOnly}

                                        created={created}
                                        updated={updated}

                                        launch={launch}
                                        norm={norm}
                                        daily={daily}
                                        subject={subject}
                                        reason={reason}
                                        resolved={resolved}
                                        participants={participants}
                                        setLaunch={setLaunch}
                                        setNorm={setNorm}
                                        setDaily={setDaily}
                                        setSubject={setSubject}
                                        setReason={setReason}
                                        setResolved={setResolved}
                                        setParticipants={setParticipants}
                                    />
                                </Form>
                            </Card.Body>
                            <Card.Footer className="text-right">
                                <Button className="me-2" onClick={ (e) => onClick_CancelEncounter(e) } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                                {!props.viewOnly && <Button onClick={ (e) => onClick_SaveEncounter(e) } disabled={sending} variant="contained" color="primary">
                                    { sending ? <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSave className="me-2" size={22} /> } {' '}
                                    {display.buttom.save}
                                </Button>}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewCadastreForm

    return (
        <>
            { viewCadastreForm() }
        </>
    );

}

export default EncounterCondominiumForm;
